import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function TargetAudience() {
  const points = ['Atendés pacientes con TDAH o TEA y sentís que la preparación de materiales y la burocracia te están "comiendo" la vida personal.', 'Perdés horas redactando informes de CUD que después la prepaga te rebota por "tecnicismos" que nunca te enseñaron en la facultad.', 'Tu WhatsApp es un campo minado de audios, preguntas de medicación y urgencias falsas que te siguen hasta el domingo a la noche.', 'Querés dejar de ser el médico que "explica todo de nuevo en cada consulta" y empezar a ser el que entrega un sistema que habla por vos.', 'Necesitás una forma profesional de demostrarle a las familias que el tratamiento está avanzando, con datos reales y no con "me parece que mejoró".', 'Querés blindar tu consultorio legalmente con consentimientos actualizados sin pagar horas de consulta con abogados.'];
  return <section className="py-20 bg-[#111827] border-y border-gray-800/50" data-id="element-253">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-254">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-255">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-12 text-center" data-id="element-256">
            ESTE MEGA KIT ES PARA VOS SI...
          </h2>

          <div className="space-y-6" data-id="element-257">
            {points.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start gap-4 p-4 rounded-xl hover:bg-[#1a2332] transition-colors" data-id="element-258">
                <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-259" />
                <p className="text-lg text-gray-300 leading-relaxed" data-id="element-260">{point}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}